import Element from 'element-ui';
import '../../assets/styles/element-variables.scss';

export default Element
